import { Lightning, Img } from "@lightningjs/sdk";
import { gridHeight, gridWidth } from "../../services/grid.service";

export default class RadiostationCard extends Lightning.Component {
  static _template() {
    return {
      Card: {
        w: 12 * gridHeight,
        h: 12 * gridHeight,
        y: 0,
        x: 0,
        alpha: 0.66,
        Image: {
          texture: "",
          alpha: 1,
          w: 12 * gridHeight,
          h: 12 * gridHeight,
          scale: 0.75,
        },
      },
      RadiostationName: {
        zIndex: 10,
        w: 24 * gridHeight,
        mountY: 0.4,
        y: 1.3 * gridHeight,
        x: -6 * gridHeight,
        rect: true,
        color: 0xffffffff,
        alpha: 0.66,
        text: {
          text: "",
          fontFace: "Roboto-Bold",
          fontSize: 54,
          textColor: 0xffffffff,
          textAlign: "center",
          verticalAlign: "top",
          alpha: 1,
          transitions: {
            fontSize: {
              duration: 0.25,
              timingFunction: "linear",
            },
          },
        },
      },
      RadiostationDescription: {
        zIndex: 10,
        w: 20 * gridHeight,
        h: 3 * gridHeight,
        y: 11.5 * gridHeight,
        x: -4 * gridHeight,
        alpha: 0,
        text: {
          text: "",
          fontFace: "Roboto-Italic",
          fontSize: 24,
          lineHeight: 0.75 * gridHeight,
          textColor: 0xffffffff,
          textAlign: "center",
          verticalAlign: "top",
          alpha: 1,
          transitions: {
            fontSize: {
              duration: 0.25,
              timingFunction: "linear",
            },
          },
        },
      },
    };
  }

  _init() {
    this.application.on("appInactive", this.onApplicationInactivity.bind(this));
    this.application.on("appActive", this.onApplicationActivity.bind(this));
  }

  onApplicationInactivity() {
    if (!this.isActiveItem) {
      this.tag("Card").patch({
        smooth: {
          alpha: 0,
        },
      });
      this.tag("RadiostationName").patch({
        smooth: {
          alpha: 0,
        },
      });
      this.tag("RadiostationDescription").patch({
        smooth: {
          alpha: 0,
        },
      });
    }
  }

  onApplicationActivity() {
    if (!this.isActiveItem) {
      this.tag("Card").patch({
        smooth: {
          alpha: 0.66,
        },
      });
      this.tag("RadiostationName").patch({
        smooth: {
          alpha: 0.66,
        },
      });
    }
  }

  _focus() {
    this.isFocused = true;
    if (this.isActiveItem) {
      this.patch({
        Card: {
          alpha: 1,
          Image: {
            smooth: {
              scale: 1,
            },
          },
        },
        RadiostationName: {
          smooth: {
            alpha: 1,
            y: 6 * gridHeight,
          },
          text: {
            fontSize: 120,
          },
        },
      });
    } else {
      this.patch({
        Card: {
          alpha: 1,
        },
        RadiostationName: {
          smooth: {
            alpha: 1,
          },
        },
        RadiostationDescription: {
          smooth: {
            alpha: 1,
          },
        },
      });
    }
  }

  _unfocus() {
    this.isFocused = false;
    this.patch({
      Card: {
        alpha: 0.66,
        Image: {
          smooth: {
            scale: 0.75,
          },
        },
      },
      RadiostationName: {
        smooth: {
          y: 1.3 * gridHeight,
          alpha: 0.66,
        },
        text: {
          fontSize: 54,
        },
      },
      RadiostationDescription: {
        smooth: {
          alpha: 0,
        },
      },
    });
  }

  set radiostationImage(radiostationImage) {
    this.tag("Card").patch({
      Image: {
        texture: Img(radiostationImage).exact(12 * gridHeight, 12 * gridHeight),
      },
    });
  }

  set radiostationName(radiostationName) {
    this.tag("RadiostationName").patch({
      text: { text: radiostationName },
    });
  }

  set radiostationDescription(radiostationDescription) {
    this.tag("RadiostationDescription").patch({
      text: { text: radiostationDescription },
    });
  }

  set itemAlpha(itemAlpha) {
    this.patch({
      Card: {
        alpha: itemAlpha,
      },
      RadiostationName: {
        smooth: {
          alpha: itemAlpha,
        },
      },
    });
  }

  set activeItem(isItemActive) {
    this.isActiveItem = isItemActive;
    if (this.isFocused && this.isActiveItem) {
      this.patch({
        Card: {
          alpha: 1,
          Image: {
            smooth: {
              scale: 1,
            },
          },
        },
        RadiostationName: {
          smooth: {
            alpha: 1,
            h: 3 * gridHeight,
            y: 6 * gridHeight,
          },
          text: {
            fontSize: 120,
          },
        },
        RadiostationDescription: {
          smooth: {
            alpha: 0,
          },
        },
      });
    } else if (!this.isActiveItem) {
      this.patch({
        Card: {
          alpha: 0.66,
          Image: {
            smooth: {
              scale: 0.75,
            },
          },
        },
        RadiostationName: {
          smooth: {
            y: 1.3 * gridHeight,
            alpha: 0.66,
          },
          text: {
            fontSize: 54,
          },
        },
        RadiostationDescription: {
          smooth: {
            alpha: 0,
          },
        },
      });
    }
  }

  static get width() {
    return 12 * gridWidth;
  }

  static get height() {
    return 12 * gridWidth;
  }

  static get channelId() {
    return 12;
  }
}
